module.exports = __webpack_public_path__ + "img/bg_tech-computer.b79180c5.jpg";